import { FARES_FAMILY } from './legs-status.enum';

export const UPGRADE_CONSTANTS = {
  GROUP_CODE: 'UP',
  RFIC_SUBCODE: '060',
  RFIC_CODE: 'A',
  SSR_CODE: 'ASVC',
  VENDOR: 'QPX',
  EMD_TYPE: '2',
  EMD_TYPE_NAME: 'Associated',
  SEGMENT_INDICATOR: 'S',
} as const;

export const PREMIER_FARE_FAMILIES: FARES_FAMILY[] = [
  FARES_FAMILY.PREMIER,
  FARES_FAMILY.PREMIER_BASIC,
  FARES_FAMILY.PREMIER_CLASSIC,
  FARES_FAMILY.PREMIER_FLEX,
  FARES_FAMILY.PREMIERONE,
  FARES_FAMILY.PREMIERONE_BASIC,
  FARES_FAMILY.PREMIERONE_CLASSIC,
  FARES_FAMILY.PREMIERONE_FLEX,
  FARES_FAMILY.FIRST_CLASS,
];

export const AIRCRAFT_NAMES: Record<string, string> = {
  787: 'Dreamliner 787-8',
  789: 'Dreamliner 787-9',
  '7M8': 'Dreamliner 787-8',
  '7M9': 'Dreamliner 787-9',
  738: 'Boeing 737-800',
  '7S8': 'Boeing 737-800',
  E70: 'Embraer 170',
  E7S: 'Embraer 170',
  E90: 'Embraer 190',
  E95: 'Embraer 195',
  E9S: 'Embraer 190',
};

export const CABIN_NAMES: Record<string, string> = {
  MAIN_LIGHT: 'upgrade.cabin.tourist',
  MAIN_BASIC: 'upgrade.cabin.tourist',
  MAIN_CLASSIC: 'upgrade.cabin.tourist',
  BASIC: 'upgrade.cabin.tourist',
  CLASSIC: 'upgrade.cabin.tourist',
  AMPLUS: 'upgrade.cabin.amplus',
  AMPLUS_BASIC: 'upgrade.cabin.amplus',
  PREMIER: 'upgrade.cabin.premier',
  PREMIER_BASIC: 'upgrade.cabin.premier',
  PREMIER_CLASSIC: 'upgrade.cabin.premier',
  PREMIER_FLEX: 'upgrade.cabin.premier',
  PREMIERONE: 'upgrade.cabin.premier',
  PREMIERONE_BASIC: 'upgrade.cabin.premier',
  PREMIERONE_CLASSIC: 'upgrade.cabin.premier',
  PREMIERONE_FLEX: 'upgrade.cabin.premier',
  FIRST_CLASS: 'upgrade.cabin.premier',
  FLEXIBLE: 'upgrade.cabin.flexible',
  COMFORT: 'upgrade.cabin.comfort',
  PREFERRED: 'upgrade.cabin.preferred',
  EXIT_ROW: 'upgrade.cabin.exit_row',
};
